module.exports = __webpack_public_path__ + "static/media/Circo2025_10.17cc5270.webp";